// tslint:disable:max-line-length
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { WorkFieldInputChangeEvent } from '../../events/work-field-input-change-event';
import { E5coreUiWorkFieldTypeBase } from '../../components/e5core-ui-work-field/e5core-ui-work-field-type-base';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-field-type-text',
  template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-work-field-type-text-box *ngSwitchCase='0' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-text-box>
    <e5core-ui-work-field-type-text-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-text-bootstrap>
    <e5core-ui-work-field-type-text-material *ngSwitchCase='2' [workItem$]='workItem$' [field]='field' [property]='property' (valueChange)='valueChange($event)' [readonly]='readonly'></e5core-ui-work-field-type-text-material>
  </span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkFieldTypeTextComponent extends E5coreUiWorkFieldTypeBase {

  constructor(public style:UiStyleService) {
    super() ;
  }

  valueChange($event: WorkFieldInputChangeEvent) {
    this.dispatchPropertyChange(this.property.propertyId, $event.value, $event.error) ;
  }

}
